import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, pageView } from "@/lib/analytics";

// Initialise GA4 une fois et envoie une page vue à chaque changement de route (SPA).
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
